{
    "Bbk": {
        "storeLocatorPoint": {
            "pageTitle": "Adresy sklepów",
            "city": "miejscowość",
            "showOnMap": "pokaż na mapie",
            "showMore": "pokaż więcej",
            "showLess": "pokaż mniej",
            "loadMore": "załaduj więcej",
            "hidePoints": "schowaj punkty",
            "moFr": "pon. - pt.",
            "sa": "sob.",
            "sn": "niedz.",
            "cityInputValidationMessage": "miejscowość jest wymagana"
        }
    }
}
